<template>
  <div v-if="content" v-editable="content" id="parc-page">
    <component :content="blok" :key="blok._uid" v-for="(blok) in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      content: null,
      id: this.$route.params.id
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const res = await api.get(
          `cdn/stories/${this.$i18n.locale}/pages/parcs/${this.id}`
        );
        this.content = res.data.story.content;
      } catch (err) {
        this.$router.push("/404");
      }
    }
  }
};
</script>

<style lang="scss">
#parc-page {
  background-color: #edefed;
  .btn-list {
    .list {
      margin-bottom: 0;
    }
  }
  .grid-component {
    background-color: #edefed;
    .grid {
      background-color: #edefed;
    }
  }
}
</style>
